'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RequestError = require('../errors/RequestError');

var _RequestError2 = _interopRequireDefault(_RequestError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Throws an error if the given fetch response has an error code.
 * @param {Object} response - The fetch response.
 * @returns {Object} The fetch response.
 * @throws {RequestError} Thrown if the fetch response is not OK.
 */
exports.default = function (response) {
  if (!response.ok) {
    throw new _RequestError2.default(response);
  }

  return response;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/requests/handleError.js
// module id = 818
// module chunks = 0